module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/pin-54deea404057a0be01faa58199a82306.svg";